export const OWNER_NAMES = "ownerNames";
export const OWNER_CHIP = "si.lead_gen_filters.category.exclude.crm.owner.chip_prefix";

export const FILTER_TRANSLATION_KEYS = {
    select: "common.select",
    ownerPlaceholder: "si.lead_gen_filters.category.exclude.crm.dropdown.owner.placeholder",
    ownerLabel: (integration: string) => `si.lead_gen_filters.filter.exclude_by_${integration}.dropdown.account.owners`,
    accountPrefix: (integration: string) =>
        `si.lead_gen_filters.filter.exclude_by_${integration}.dropdown.account.other`,
};
